import React from "react";

function FeatureArea() {
  return (
    <>
      <section className="features-area pt-120 pb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="features-item wow fadeInUp" data-wow-delay=".2s">
                <div className="features-item-inner">
                  <div className="features-content">
                    <h4 className="title">Špičkový sortiment</h4>
                    <p>
                      Nabízíme široký výběr atestovaných hutních materiálů,
                      garantující kvalitu a splňujících normy.
                    </p>
                    <a href="/products" className="link-btn">
                      <i className="fas fa-arrow-right"></i> Více informací
                    </a>
                  </div>
                  <div className="features-icon"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="features-item wow fadeInUp" data-wow-delay=".4s">
                <div className="features-item-inner">
                  <div className="features-content">
                    <h4 className="title">Atesty</h4>
                    <p>
                      Atest u hutních materiálů je certifikát nebo dokument,
                      který potvrzuje, že daný materiál splňuje stanovené normy
                      a specifikace.
                    </p>
                    <a href="/" className="link-btn">
                      <i className="fas fa-arrow-right"></i> Více informací
                    </a>
                  </div>
                  <div className="features-icon"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="features-item wow fadeInUp" data-wow-delay=".6s">
                <div className="features-item-inner">
                  <div className="features-content">
                    <h4 className="title">Služby</h4>
                    <p>
                      Pro své zákazníky zajišťujeme kompletní dodavatelský
                      servis včetně dopravy, dle dispozic zákazníka.
                    </p>
                    <a href="/services" className="link-btn">
                      <i className="fas fa-arrow-right"></i> Více informací
                    </a>
                  </div>
                  <div className="features-icon"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FeatureArea;
